/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
export * as operations from './operations';
export * from './data-contracts';
/** Version of the API specification */
export const specVersionHash = "c9a932f7fa0c21dd9c08f8b690e528dfbb8206c88e770c952822c0301266fb09";